import axios, { AxiosInstance } from "axios";
import { getApiUrl } from "./environment";

const DEFAULT_TIMEOUT = 30000;

export const createAxiosInstance = (customApi?: string): AxiosInstance => {
  return axios.create({
    baseURL: customApi ?? getApiUrl(),
    timeout: DEFAULT_TIMEOUT,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

/**
 * Hook to get an axios instance with default configuration.
 */
export const useAxiosInterceptors = (customApi?: string) => {
  const axiosInstance = createAxiosInstance(customApi);
  return axiosInstance;
};
